<template>
  <div class="contentPadding">
    <a-form layout="inline">
      <a-form-item label="考试科目编号">
        <a-input
          type="text"
          placeholder="请输入考试科目编号"
          allow-clear
          v-model:value="listQuery.subjectName"
        />
      </a-form-item>
      <a-form-item label="科目名称">
        <a-select
          v-model:value="listQuery.subjectName"
          show-search
          placeholder="请选择合伙伙伴名称"
          style="width: 200px"
          :filter-option="filterOption"
          allow-clear
        >
          <a-select-option value="jack">Jack</a-select-option>
          <a-select-option value="lucy">Lucy</a-select-option>
          <a-select-option value="tom">Tom</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :wrapper-col="{ offset: 20 }">
        <a-button type="primary" @click="handleSearch">
          查询
        </a-button>
      </a-form-item>
      <a-form-item :wrapper-col="{ offset: 15 }">
        <a-button style="margin-left: 10px" @click="onReset"> 重置 </a-button>
      </a-form-item>
    </a-form>
    <a-row class="buttonGroup">
      <a-button
        type="primary"
        class="btnMargin"
        @click="toAdd"
        v-if="isShowBtn('examSubject:add')"
      >
        <PlusOutlined />新建
      </a-button>
      <a-button v-if="isShowBtn('examSubject:del')" style="margin-left:20px;">
        批量删除
      </a-button>
    </a-row>
    <a-table
      :data-source="partnerlist"
      row-key="id"
      :pagination="pagination"
      @change="changeTable"
      :rowSelection="{ type: 'checkbox', onChange: onSelectChange }"
    >
      
      <a-table-column
        key="subjectName"
        title="科目编号"
        data-index="subjectName"
        align="center"
        :ellipsis="true"
      />
      <a-table-column
        key="subjectNo"
        title="科目名称"
        data-index="subjectNo"
        align="center"
      />
      <a-table-column
        key="certificateName"
        title="标准收费"
        data-index="certificateName"
        align="center"
      />
      <a-table-column
        key="passScore"
        title="考试收费上限"
        data-index="passScore"
        align="center"
        :width="120"
      />
      <a-table-column
        key="validity"
        title="培训+考试收费上线"
        data-index="validity"
        align="center"
        :width="120"
      />
      <a-table-column
        key="entryFee"
        title="总成绩"
        data-index="entryFee"
        align="center"
        :ellipsis="true"
      />
      <a-table-column
        key="createTime"
        title="及格线"
        data-index="createTime"
        align="center"
        :ellipsis="true"
      />
      <a-table-column
        key="createTime"
        title="报考条件预设"
        data-index="createTime"
        align="center"
        :ellipsis="true"
      />
      <a-table-column
        key="createTime"
        title="科目图片"
        data-index="createTime"
        align="center"
        :ellipsis="true"
      />
      <a-table-column key="action" title="操作" align="center" >
        <template v-slot="scope">
          <span>
            <a-button type="link" @click="detail(scope.record)">
              查看
            </a-button>
            <a-button
              type="link"
              @click="handleEdit(scope.record)"
              v-if="isShowBtn('examSubject:edit')"
            >
              修改
            </a-button>
            <a-button
              v-if="isShowBtn('examSubject:del')"
              type="link"
              @click="handleDel(scope.record)"
            >
              删除
            </a-button>
          </span>
        </template>
      </a-table-column>
    </a-table>
  </div>
  <info
    ref="partdialog"
    :info="info"
    :certificateTypeList="certificateTypeList"
    @getList="uploadGetList"
  />
</template>
<script>
import info from "./info";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { provs } from "../../../assets/province.json";
import { allcities } from "../../../assets/province.json";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { Modal, message, notification } from "ant-design-vue";
import { createVNode } from "vue";
import { deletePartner } from "../../../api/partner";
import { isShowBtn } from "@/until/tool";

const defaultform = {
  province: null,
  city: null,
  companyName: "",
  pageIndex: 1,
  pageSize: 10
};
export default {
  name: "",
  props: {},
  data() {
    return {
      certificateTypeList: null,
      fileCode: null,
      partnerlist: null,
      listQuery: {
        subjectName: "",
        pageSize: 10,
        pageIndex: 1
      },
      info: {
        isAdd: true,
        isShow: false,
        isSee: false
      },
      pagination: {
        // 分页配置器
        pageSize: 10, // 一页的数据限制
        current: 1, // 当前页
        total: 0, // 总数
        hideOnSinglePage: false, // 只有一页时是否隐藏分页器
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true, // 是否可以改变 pageSize
        pageSizeOptions: ["5", "10", "30"] // 指定每页可以显示多少条
      }
    };
  },
  components: {
    info
  },
  mounted() {
    this.selectCertificateType();
    this.getList();
  },
  methods: {
    isShowBtn,
    // 证书类型
    selectCertificateType() {
      this.$store
        .dispatch("SelectCertificateType")
        .then(res => {
          if (res.code === 0) {
            this.certificateTypeList = res.data;
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    uploadGetList() {
      console.log("abc");
      this.getList();
    },
    // 搜索框过滤
    filterOption(input, option) {
      return option.children[0].children.indexOf(input) !== -1;
    },
    // 表格选择
    onSelectChange(nodes, nodeIds) {
      console.log(nodes, nodeIds);
    },
    // 查看
    handleShow(rowData) {
      this.title = "角色信息";
      this.isShow = true;
      this.showModal = true;
      this.$store
        .dispatch("SelectRoleById", { id: rowData.roleId })
        .then(res => {
          if (res.code === 0) {
            this.checkedKeys = res.data.menuIdList;
            this.roleInfo = res.data;
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    // 修改
    handleEdit(rowData) {
      this.info.isAdd = false;
      this.info.isShow = true;
      this.$refs.partdialog.setRowData(rowData);
    },
    // 查询
    handleSearch() {
      this.listQuery.pageIndex = "1";
      this.listQuery.pageSize = this.pagination.pageSize;
      this.getList();
    },
    //重置
    onReset() {
      this.listQuery.subjectName = "";
    },
    // 列表
    getList() {
      this.loading = true;
      this.$store
        .dispatch("SelectExamSubjectPage", this.listQuery)
        .then(res => {
          if (res.code === 0) {
            if (
              res.data.currPage > res.data.totalPage &&
              res.data.totalPage !== 0
            ) {
              this.listQuery.pageIndex = res.data.totalPage;
              this.getList();
            } else {
              this.listQuery.pageIndex = res.data.currPage;
            }
            this.partnerlist = res.data.list;
            this.listQuery.pageSize = res.data.pageSize;
            this.pagination.current = res.data.currPage;
            this.pagination.pageSize = res.data.pageSize;
            this.pagination.total = res.data.totalCount;
            this.loading = false;
          } else {
            this.loading = false;
            // this.$message.error(res.msg);
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    // 删除
    handleDel(rowData) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      Modal.confirm({
        title: "确认删除",
        icon: createVNode(ExclamationCircleOutlined),
        content: "删除操作不可撤销，请谨慎操作。",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          self.$store
            .dispatch("DeleteExamSubject", rowData.id)
            .then(res => {
              if (res.code === 0) {
                notification["success"]({
                  message: "已删除"
                });
                self.getList();
              } else {
                self.$handleErr(res);
              }
            })
            .catch(err => {
              self.$handleErr(err);
            });
        }
      });
    },
    // 删除多条数据
    handleAllDel() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      if (this.selectRowIds.length === 0) {
        this.$message.warning("请先选择数据，在进行批量删除操作");
        return false;
      }
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      Modal.confirm({
        title: "确认批量删除",
        icon: createVNode(ExclamationCircleOutlined),
        content: "删除操作不可撤销，请谨慎操作。",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          self.$store
            .dispatch("DeleteUserBatchById", self.selectRowIds.join(","))
            .then(res => {
              if (res.code === 0) {
                notification["success"]({
                  message: "已删除"
                });
                self.selectRowIds = "";
                self.getList();
              } else {
                self.$handleErr(res);
              }
            })
            .catch(err => {
              self.$handleErr(err);
            });
        },
        onCancel() {}
      });
    },
    // 分页、排序、筛选变化时触发
    changeTable(pagination, filters, sorter) {
      this.listQuery.pageIndex = pagination.current;
      this.listQuery.pageSize = pagination.pageSize;
      this.getList();
    },
    // 新建
    toAdd() {
      this.info.isAdd = true;
      this.info.isShow = true;
      this.$refs.partdialog.temp();
      this.$refs.partdialog.getFileCode();
    },
    detail(rowData) {
      this.info.isSee = true;
      this.$refs.partdialog.setRowData(rowData);
    }
  }
};
</script>
<style lang="scss" scoped></style>
